import { create } from 'zustand';
import { devtools } from "zustand/middleware";
import type { IIntegrationsStore } from '../types/zustand/integrations';

export const useIntegrationsStore = create<IIntegrationsStore>()(
  devtools(
    (set) => ({
      hasLiveIntegration: false,
      setHasLiveIntegration: (hasLiveIntegration) => set(() => ({ hasLiveIntegration }),
        undefined,
        'IntegrationsStore/setHasLiveIntegration'
      ),

      paymentMethodIntegrations: undefined,
      setPaymentMethodIntegrations: (paymentMethodIntegrations) => set(() => ({ paymentMethodIntegrations }),
        undefined,
        'IntegrationsStore/setPaymentMethodIntegrations'
      ),

      currencies: undefined,
      setCurrencies: (currencies) => set(() => ({ currencies }),
        undefined,
        'IntegrationsStore/setCurrencies'
      ),

      methods: undefined,
      setMethods: (methods) => set(() => ({ methods }),
        undefined,
        'IntegrationsStore/setMethods'
      ),

      isError: false,
      setIsError: (isError) => set(() => ({ isError }),
        undefined,
        'IntegrationsStore/setIsError'
      ),

      isLoading: false,
      setIsLoading: (isLoading) => set(() => ({ isLoading }),
        undefined,
        'IntegrationsStore/setIsLoading'
      ),
    } as IIntegrationsStore),
    { name: 'IntegrationsStore' }
  )
);